import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, ɵɵsetComponentScope } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { DatosActa, ResponseDatosActa } from 'src/app/model/DatosActa.model';
import { DatosEncuestaActa, DatosEncuestaActaPM } from 'src/app/model/DatosEncuestaActa.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { JardinTutoria, ResponseJardinTutoria } from 'src/app/model/JardinTutoria.model';
import { apiService } from 'src/app/service/api.service';
import { StorageService } from 'src/app/service/storage.service';
import { TutoriaService } from 'src/app/service/tutoria.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service'
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ModalVideoComponent } from '../dialogs/modal-video/modal-video.component';
import { JardinPMTutoria, ResponseJardinPMTutoria } from 'src/app/model/JardinPMTutoria.model';
import { DatosActaPM, ResponseDatosActaPM } from 'src/app/model/ActaModelPMData';

@Component({
  selector: 'app-aula-virtual',
  templateUrl: './aula-virtual.component.html',
  styleUrls: ['./aula-virtual.component.css']
})
export class AulaVirtualComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  @Input() simulacion: boolean;
  cargando :boolean;
  showAgenda :boolean;
  showNotas :boolean;
  showNotasPM :boolean;
  jardinTutoriaSelected : JardinTutoria;
  responseJardinTutoria : ResponseJardinTutoria = new ResponseJardinTutoria();
  responseJardinPMTutoria : ResponseJardinPMTutoria = new ResponseJardinPMTutoria();
  jardinTutoria1 : JardinTutoria = new JardinTutoria();
  jardinTutoria2 : JardinTutoria = new JardinTutoria();
  jardinTutoria3 : JardinTutoria = new JardinTutoria();
  jardinTutoria4 : JardinTutoria = new JardinTutoria();

  etapaPM1 : JardinPMTutoria = new JardinPMTutoria();
  etapaPM2 : JardinPMTutoria = new JardinPMTutoria();
  etapaPM3 : JardinPMTutoria = new JardinPMTutoria();
  etapaPM4 : JardinPMTutoria = new JardinPMTutoria();

  public isCollapsed1 = true;
  public isCollapsed2 = true;
  public isCollapsed3 = true;
  public isCollapsed4 = true;
  public isCollapsed5 = true;



  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalValidarActa') modalValidarActa: TemplateRef<any>;
  @ViewChild('modalValidarActaPM') modalValidarActaPM: TemplateRef<any>;
  @ViewChild('modalRevisarActaPM') modalRevisarActaPM: TemplateRef<any>;
  
  
  modalData: {
    jardinTutoria: JardinTutoria;
  };

  modalDataActa: {
    datosActa: DatosActa;
    dataJardin : JardinModel;
    modulo : String;
    datosEncuestaActa : DatosEncuestaActa;
    jardinTutoria:JardinTutoria;
  };

  modalDataActaPM: {
    datosActa: DatosActaPM;
    dataJardin : JardinModel;
    modulo : String;
    jardinPMTutoria:JardinPMTutoria;
    datosEncuestaActaPM : DatosEncuestaActaPM;
  };


  constructor(
    config: NgbPopoverConfig,
    private tutoriaService: TutoriaService,
    private storageService: StorageService,
    private planMejoraService: PlanMejoraService,
    private api: apiService,
    private modal: NgbModal,
    public dialog: MatDialog,
  ) { 
    config.placement = 'right';
    config.triggers = 'hover';
  }

  ngOnInit(): void {
    this.cargando = true;
    this.showAgenda = false;
    this.showNotas = false;
    this.showNotasPM = false;
    this.cargaInicial();
  }

  cargaInicial(){
    this.getTutorias(this.storageService.getCurrentUser().idUsuario);
    this.getPlanMejora(this.storageService.getCurrentUser().idUsuario);
  }
  


  getTutorias(idUsuario:number){
    if(this.simulacion){
      
      this.tutoriaService.API_POST_getTutoriasByIdUsuario(this.api.dataJardin.idUsuario).subscribe((response: ResponseJardinTutoria) => {
        this.responseJardinTutoria = response;
        this.responseJardinTutoria.payload.forEach((tutoria)=>{
          switch (tutoria.numeroTutoria) {
            case 1: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria1 = tutoria;
              this.jardinTutoria1.fechaInicioTutoria = fechaInicio;
              this.jardinTutoria1 = tutoria;
              break;
            }
            case 2: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria2 = tutoria;
              this.jardinTutoria2.fechaInicioTutoria = fechaInicio;
              break;
            }
            case 3: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria3 = tutoria;
              this.jardinTutoria3.fechaInicioTutoria = fechaInicio;
              break;
            }
            case 4: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria4 = tutoria;
              this.jardinTutoria4.fechaInicioTutoria = fechaInicio;
              break;
            }           
          }
        });
        this.cargando = false;
        this.divSpinner.nativeElement.style.display='none';
      },
      (err) => {
        console.log(err)
      })
    }else{
      this.tutoriaService.API_POST_getTutoriasByIdUsuario(idUsuario).subscribe((response: ResponseJardinTutoria) => {
        this.responseJardinTutoria = response;
        this.responseJardinTutoria.payload.forEach((tutoria)=>{
          switch (tutoria.numeroTutoria) {
            case 1: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria1 = tutoria;
                this.jardinTutoria1.fechaInicioTutoria = fechaInicio;  
              }else{
                this.jardinTutoria1 = tutoria;
              }
              
              break;
            }
            case 2: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria2 = tutoria;
                this.jardinTutoria2.fechaInicioTutoria = fechaInicio;
              }else{
                this.jardinTutoria2 = tutoria;
              }
              break;
            }
            case 3: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria3 = tutoria;
                this.jardinTutoria3.fechaInicioTutoria = fechaInicio;
              }else{
                this.jardinTutoria3 = tutoria;
              }
              break;
            }
            case 4: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria4 = tutoria;
                this.jardinTutoria4.fechaInicioTutoria = fechaInicio;
              }else{
                this.jardinTutoria4 = tutoria;
              }
              break;
            }           
          }
        });
        this.cargando = false;
        this.divSpinner.nativeElement.style.display='none';
      },
      (err) => {
        console.log(err)
      })
    }
  }

  getPlanMejora(idUsuario:number){

    if(this.simulacion){
      
    this.planMejoraService.API_POST_getEtapasPlanMejoraJardin(this.api.dataJardin.idUsuario).subscribe((response: any) => {
        this.responseJardinPMTutoria = response;
        this.responseJardinPMTutoria.payload.forEach((tutoria)=>{
          switch (tutoria.idSesion) {
            case 1: {
              let fechaInicio = new Date(tutoria.fechaAgenda);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.etapaPM1 = tutoria;
              this.etapaPM1.fechaAgenda = fechaInicio;
              this.etapaPM1 = tutoria;
              break;
            }
            case 2: {
              let fechaInicio = new Date(tutoria.fechaAgenda);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.etapaPM2 = tutoria;
              this.etapaPM2.fechaAgenda = fechaInicio;
              break;
            }
            case 3: {
              let fechaInicio = new Date(tutoria.fechaAgenda);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.etapaPM3 = tutoria;
              this.etapaPM3.fechaAgenda = fechaInicio;
              break;
            }
            case 4: {
              let fechaInicio = new Date(tutoria.fechaAgenda);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.etapaPM4 = tutoria;
              this.etapaPM4.fechaAgenda = fechaInicio;
              break;
            }           
          }
        });
        this.cargando = false;
        this.divSpinner.nativeElement.style.display='none';
      },
      (err) => {
        console.log(err)
      })
    }else{
      this.planMejoraService.API_POST_getEtapasPlanMejoraJardin(idUsuario).subscribe((response: ResponseJardinPMTutoria) => {
        this.responseJardinPMTutoria = response;
        this.responseJardinPMTutoria.payload.forEach((tutoria)=>{

          switch (tutoria.idSesion) {
            case 1: {
              if(tutoria.fechaAgenda != null){
                let fechaInicio = new Date(tutoria.fechaAgenda);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.etapaPM1 = tutoria;
                this.etapaPM1.fechaAgenda = fechaInicio;  
              }else{
                this.etapaPM1 = tutoria;
              }
              
              break;
            }
            case 2: {
              if(tutoria.fechaAgenda != null){
                let fechaInicio = new Date(tutoria.fechaAgenda);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.etapaPM2 = tutoria;
                this.etapaPM2.fechaAgenda = fechaInicio;
              }else{
                this.etapaPM2 = tutoria;
              }
              break;
            }
            case 3: {
              if(tutoria.fechaAgenda != null){
                let fechaInicio = new Date(tutoria.fechaAgenda);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.etapaPM3 = tutoria;
                this.etapaPM3.fechaAgenda = fechaInicio;
              }else{
                this.etapaPM3 = tutoria;
              }
              break;
            }
            case 4: {
              if(tutoria.fechaAgenda != null){
                let fechaInicio = new Date(tutoria.fechaAgenda);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.etapaPM4 = tutoria;
                this.etapaPM4.fechaAgenda = fechaInicio;
              }else{
                this.etapaPM4 = tutoria;
              }
              break;
            }           
          }
        });
        this.cargando = false;
        this.divSpinner.nativeElement.style.display='none';
      },
      (err) => {
        console.log(err)
      })
    }
    
  }


  agendar(jardinTutoria:JardinTutoria){
    this.jardinTutoriaSelected = jardinTutoria;
    this.showAgenda = true;
  }

  openNotas(){
    this.showNotas = true;
  }

  openNotasPM(){
    this.showNotasPM = true;
  }

  showActaTutoria(jardinTutoria:JardinTutoria): void {

    var pdfDocumentSrc = environment.apiEndpoint + "tutoria/getActaPDF/" + jardinTutoria.idJardinPeriodoTutoria;
    const dialogRef = 
    this.dialog.open(ModalVideoComponent, {
      disableClose: true ,
      data: {url: pdfDocumentSrc ,size: 'xl'}
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  
  detalleAgendaModal(jardinTutoria:JardinTutoria): void {
    this.modalData = { jardinTutoria };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  validarActaModal(jardinTutoria:JardinTutoria): void {
    this.divSpinner.nativeElement.style.display='';
    this.tutoriaService.API_POST_getActaData(jardinTutoria.idJardinPeriodoTutoria).subscribe((response: ResponseDatosActa) => {
      let datosActa = response.payload;

      let fechaInicio = new Date(datosActa.fechaInicio);
      fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
      let fechaFin = new Date(datosActa.fechaFin);
      fechaFin.setTime( fechaFin.getTime() + fechaFin.getTimezoneOffset()*60*1000 );

      datosActa.fechaInicio = fechaInicio;
      datosActa.fechaFin = fechaFin;
      
      let modulo = "";
      switch (jardinTutoria.numeroTutoria) {
        case 1: {
          modulo = "Módulo Introductorio";
          break;
        }
        case 2: {
          modulo = "Módulo Profundización del PEI en relación con el MGCEP";
          break;
        }
        case 3: {
          modulo = "Módulo Metodología de Autoevaluación";
          break;
        }
        case 4: {
          modulo = "Módulo Aspectos prácticos de la Reunión de Validación";
          break;
        }           
      }
      let dataJardin = this.api.dataJardin
      let datosEncuestaActa = new DatosEncuestaActa();
      this.modalDataActa = { datosActa, dataJardin,modulo,datosEncuestaActa,jardinTutoria};
      this.modal.open(this.modalValidarActa, { size: 'lg' });
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      this.divSpinner.nativeElement.style.display='';
      console.log(err)
    })
  
  }

  validarActaPMModal(jardinPMTutoria:JardinPMTutoria): void {
    this.divSpinner.nativeElement.style.display='';
    this.planMejoraService.API_POST_getActaJardinTutorPlanMejora(this.api.dataJardin.idJardinPeriodo,jardinPMTutoria.idSesion).subscribe((response: any) => {
      let datosActa = response.payload;

      let fechaInicio = new Date(datosActa.fechaInicio);
      fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
      let fechaFin = new Date(datosActa.fechaFin);
      fechaFin.setTime( fechaFin.getTime() + fechaFin.getTimezoneOffset()*60*1000 );

      var cambioHora = new Date("04-02-2022"); //Ajustar según cambio horario.

      if (fechaInicio>cambioHora) {
        fechaInicio.setHours( fechaInicio.getHours() - 1 ); 
      }
  
      if (fechaFin>cambioHora) {
        fechaFin.setHours( fechaFin.getHours() - 1 ); 
      }

      fechaInicio.setHours( fechaInicio.getHours() - 3 );
      fechaFin.setHours( fechaFin.getHours() - 3 );
      
      datosActa.fechaInicio = fechaInicio;
      datosActa.fechaFin = fechaFin;
      
      let modulo = "";
      switch (jardinPMTutoria.idSesion) {
        case 1: {
          modulo = "Módulo 1";
          break;
        }
        case 2: {
          modulo = "Módulo 2";
          break;
        }
        case 3: {
          modulo = "Módulo 3";
          break;
        }
        case 4: {
          modulo = "Módulo 4";
          break;
        }           
      }
      let dataJardin = this.api.dataJardin
      let datosEncuestaActaPM = new DatosEncuestaActaPM();
      datosEncuestaActaPM.evaluacion1 = datosActa.evaluacion1;
      datosEncuestaActaPM.evaluacion2 = datosActa.evaluacion2;
      datosEncuestaActaPM.evaluacion3 = datosActa.evaluacion3;
      datosEncuestaActaPM.evaluacion4 = datosActa.evaluacion4;
      datosEncuestaActaPM.evaluacion5 = datosActa.evaluacion5;
      datosEncuestaActaPM.evaluacion6 = datosActa.evaluacion6;
      this.modalDataActaPM = { datosActa, dataJardin, modulo, jardinPMTutoria, datosEncuestaActaPM};
      this.modal.open(this.modalValidarActaPM, { size: 'lg' });
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      this.divSpinner.nativeElement.style.display='';
      console.log(err)
    })
  }

  revisarActaPMModal(jardinPMTutoria:JardinPMTutoria): void {
    this.divSpinner.nativeElement.style.display='';
    this.planMejoraService.API_POST_getActaJardinTutorPlanMejora(this.api.dataJardin.idJardinPeriodo,jardinPMTutoria.idSesion).subscribe((response: any) => {
      let datosActa = response.payload;

      let fechaInicio = new Date(datosActa.fechaInicio);
      let fechaFin = new Date(datosActa.fechaFin);
      fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
      fechaFin.setTime( fechaFin.getTime() + fechaFin.getTimezoneOffset()*60*1000 );

      var cambioHora = new Date("04-02-2022"); //Ajustar según cambio horario.

      if (fechaInicio>cambioHora) {
        fechaInicio.setHours( fechaInicio.getHours() - 1 ); 
      }
  
      if (fechaFin>cambioHora) {
        fechaFin.setHours( fechaFin.getHours() - 1 ); 
      }

      fechaInicio.setHours( fechaInicio.getHours() - 3 );
      fechaFin.setHours( fechaFin.getHours() - 3 );

      datosActa.fechaInicio = fechaInicio;
      datosActa.fechaFin = fechaFin;
      
      let modulo = "";
      switch (jardinPMTutoria.idSesion) {
        case 1: {
          modulo = "Módulo 1";
          break;
        }
        case 2: {
          modulo = "Módulo 2";
          break;
        }
        case 3: {
          modulo = "Módulo 3";
          break;
        }
        case 4: {
          modulo = "Módulo 4";
          break;
        }           
      }
      let dataJardin = this.api.dataJardin
      let datosEncuestaActaPM = new DatosEncuestaActaPM();
      datosEncuestaActaPM.evaluacion1 = datosActa.evaluacion1;
      datosEncuestaActaPM.evaluacion2 = datosActa.evaluacion2;
      datosEncuestaActaPM.evaluacion3 = datosActa.evaluacion3;
      datosEncuestaActaPM.evaluacion4 = datosActa.evaluacion4;
      datosEncuestaActaPM.evaluacion5 = datosActa.evaluacion5;
      datosEncuestaActaPM.evaluacion6 = datosActa.evaluacion6;
      this.modalDataActaPM = { datosActa, dataJardin, modulo, jardinPMTutoria, datosEncuestaActaPM};
      this.modal.open(this.modalRevisarActaPM, { size: 'lg' });
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      this.divSpinner.nativeElement.style.display='';
      console.log(err)
    })
  }



  validarActa(modalDataActa){
    if(modalDataActa.datosActa.comentarioJardin != null){
      if(modalDataActa.datosEncuestaActa.pregunta1 >= 0 && modalDataActa.datosEncuestaActa.pregunta2 >= 0
        && modalDataActa.datosEncuestaActa.pregunta3 >= 0 && modalDataActa.datosEncuestaActa.pregunta4 >= 0
        && modalDataActa.datosEncuestaActa.pregunta5 >= 0 && modalDataActa.datosEncuestaActa.pregunta6 >= 0){
          this.divSpinner.nativeElement.style.display='';
          let datosEncuestaActa : DatosEncuestaActa = modalDataActa.datosEncuestaActa;
          datosEncuestaActa.idJardinPeriodoTutoria = modalDataActa.jardinTutoria.idJardinPeriodoTutoria;
          datosEncuestaActa.comentarioJardin = modalDataActa.datosActa.comentarioJardin;
          datosEncuestaActa.idActaTutoria = modalDataActa.datosActa.idActaTutoria;
          this.tutoriaService.API_POST_finalizarActaJardin(datosEncuestaActa).subscribe((response: any) => {
            this.divSpinner.nativeElement.style.display='none';
            this.close();
            this.ngOnInit();
            
          },
          (err) => {
            this.divSpinner.nativeElement.style.display='';
            console.log(err)
          })
      }else{
        Swal.fire({
          title: 'UPS!',
          text: 'Debe completar la encuesta',
          icon: 'info',
          confirmButtonText: 'OK'
        })
      }
    }else{
      Swal.fire({
        title: 'UPS!',
        text: 'Debe ingresar un comentario',
        icon: 'info',
        confirmButtonText: 'OK'
      })
    }

  }

  firmarActaPM(modalDataActaPM){
    if(modalDataActaPM.datosActa.observacionDirectora != null && modalDataActaPM.datosActa.observacionDirectora != ""){
      if(modalDataActaPM.datosEncuestaActaPM.evaluacion1 >= 0 && modalDataActaPM.datosEncuestaActaPM.evaluacion2 >= 0
        && modalDataActaPM.datosEncuestaActaPM.evaluacion3 >= 0 && modalDataActaPM.datosEncuestaActaPM.evaluacion4 >= 0
        && modalDataActaPM.datosEncuestaActaPM.evaluacion5 >= 0 && modalDataActaPM.datosEncuestaActaPM.evaluacion6 >= 0){
          this.divSpinner.nativeElement.style.display='';
          let datosEncuestaActaPm : DatosEncuestaActaPM = modalDataActaPM.datosEncuestaActaPM;
          datosEncuestaActaPm.idActaTutorPlanMejora = modalDataActaPM.datosActa.idActaTutorPlanMejora;
          datosEncuestaActaPm.observacionDirectora = modalDataActaPM.datosActa.observacionDirectora;
          datosEncuestaActaPm.idJardinPeriodo = modalDataActaPM.dataJardin.idJardinPeriodo;
          datosEncuestaActaPm.estadoActa = 2;
          datosEncuestaActaPm.numeroActa = modalDataActaPM.datosActa.numeroActa;
          datosEncuestaActaPm.fechaFirmaJardin = new Date();
          this.planMejoraService.API_POST_firmaActaJardinPlanMejora(datosEncuestaActaPm).subscribe((response: any) => {
            this.divSpinner.nativeElement.style.display='none';
            this.close();
            this.ngOnInit();
            
          },
          (err) => {
            this.divSpinner.nativeElement.style.display='';
            console.log(err)
          })
      }else{
        Swal.fire({
          title: 'UPS!',
          text: 'Debe completar la encuesta',
          icon: 'info',
          confirmButtonText: 'OK'
        })
      }
    }else{
      Swal.fire({
        title: 'UPS!',
        text: 'Debe ingresar una observación',
        icon: 'info',
        confirmButtonText: 'OK'
      })
    }
  }


  verVideo(nombre){
    switch(nombre){
      case 'intro1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/N6d2t5UVcZQ'}
          });

          dialogRef.afterClosed().subscribe(result => {
          });
        break;
      }
      case 'intro2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/psG1mEM3jpY'}
          });

          dialogRef.afterClosed().subscribe(result => {
          });
        break;
      }
      case 'intro3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/yinU5o5sAds',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {
          });
        break;
      } 

      case 'intro4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/IGDE.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      } 

      case 'intro5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/MMGCEP.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      } 

      case 'intro6':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/whS0fucUI5A'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion1cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            //data: {url: 'https://www.youtube.com/embed/0Y_ADgcdjzo',size: 'xl'}
            data: {url: 'https://www.youtube.com/embed/gCMaW1wydqI',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      
      case 'sesion1cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            //data: {url: 'https://www.youtube.com/embed/Dd59j3MNi6o'}
            data: {url: 'https://www.youtube.com/embed/Whwze4jv2VI'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion1cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/tX6NyabhLCI'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion1ppt1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/PptM1.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            //data: {url: 'https://view.genial.ly/614a4c64de5ed50d9f1349a4',size: 'xl'}
            data: {url: 'https://www.youtube.com/embed/QMAfyP-H3a0',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion2ppt1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/PptM2.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: ''}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: ''}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/Orientaciones-para-Elaborar-el-Proyecto-Educativo-Institucional-en-eep.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/Anexo1PEIGC.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap6':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/Anexo2PEIGA.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap7':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/3bbba0c378c74c989a39bfbf1bb57ebd?themeId=1&templateId=2',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion3/GE8.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/7fjY5BL-uok',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/FJFCyuliiWc',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/9rZl_FspUHg',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion3/ppt3.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion4doc1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion4/doc1.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      
      case 'sesion4cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/ZLrIeWveOVE',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      
      case 'sesion4cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/7XKkeRbiWdU',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      
      case 'sesion4cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/riOjGmbFUFg',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion4cap4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/ddb0850d86574e509284b83cd2945366?themeId=1&templateId=35',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      
      case 'sesion4cap5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion4/ppt4.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion1ppt1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1PM/PMsesion1ppt1.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion1ppt2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1PM/PMsesion1ppt2.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion1ppt3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1PM/PMsesion1ppt3.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion1ppt4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1PM/PMsesion1ppt4.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion1cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/X45zi2hK71U',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion2cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/NEEj3mdNHYk',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion3cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/NL6Kpopu7Gg',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PMsesion4cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/2aeBBjvvx28',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM1MatClasic1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/M1_DIRECTOR_CLASIC.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM1MatClasic2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/5255716b26464b67914b8b2938d0edb0?themeId=1&templateId=3',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM1MatAlter1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/M1_ DIRECTOR_ALTER.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM2MatClasic1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/M2_DIRECTOR_CLASIC.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM2MatAlter1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/M2_DIRECTOR_ALTER.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM2MatAlter2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/ea2f85ad14b148bba13c647d16ee00b7?themeId=1&templateId=2',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM3MatClasic1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion3/M3_DIRECTOR_CLASIC.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM3MatAlter1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion3/M3_DIRECTOR_ALTER.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM4MatClasic1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion4/M4_DIRECTOR_CLASIC.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM4MatClasic2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/5c5c707eaca14ed491d1ca3120d705e6?themeId=1&templateId=8',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM4MatAlter1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion4/M4_DIRECTOR_ALTER.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'PM4MatAlter2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/5c5c707eaca14ed491d1ca3120d705e6?themeId=1&templateId=8',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

    }
  }

  closeMessage(){
    Swal.fire({
      title: 'UPS!',
      text: 'Debe completar y enviar el acta al final de esta ventana',
      icon: 'info',
      confirmButtonText: 'OK'
    })
  }

  close(){
    this.modal.dismissAll();
  }

}
